export const locales = {
  en: "English",
  de: "German",
  fr: "French",
  es: "Spanish",
  nl: "Dutch",
  it: "Italian",
  sv: "Swedish",
  nb: "Norwegian",
  ar: "Arabic",
  he: "Hebrew",
  da: "Danish",
  pl: "Polish",
  tr: "Turkish",
  pt: "Portuguese",
  ja: "Japanese",
}

export const localeCodes = Object.keys(locales)

// Arabic and Hebrew use the existing RTL text alignment in CSS (html lang
// selectors, text-align, unicode-bidi). They do not flip the page layout.
// Danish, Polish, Turkish, Portuguese, and Japanese stay left to right.
export const rtlLocaleCodes = ["ar", "he"]

// Add a code here to hide that language from routing, the switcher, and hreflang.
// Empty: every website locale above is public.
export const disabledLocaleCodes = []

export const withoutDisabledLocales = (codes = []) =>
  codes.filter((code) => !disabledLocaleCodes.includes(code))

// Sanity's enabled list is merged with every website locale. A code in
// `locales` is public unless it is listed in disabledLocaleCodes, so a new
// language routes before the Sanity locales document is updated. Sanity's
// order is kept; missing website locales follow the order in this file.
export const mergeEnabledLocales = (sanityEnabled = []) =>
  withoutDisabledLocales(
    Array.from(new Set([...(sanityEnabled ?? []), ...localeCodes]))
  )

// Sanity can enable a code this site has no name for. Drop those so the
// language menus do not render a blank option.
export const labeledLocaleCodes = (codes = []) =>
  codes.filter((code) => locales[code])

// /ar/about?x=1 -> /about?x=1. Null when the path is not a disabled locale.
export const englishPathForDisabledLocale = (resolvedUrl = "/") => {
  const [pathname, search = ""] = resolvedUrl.split("?")
  const [code, ...rest] = pathname.split("/").filter(Boolean)
  if (!disabledLocaleCodes.includes(code)) return null
  const path = `/${rest.join("/")}`
  return search ? `${path}?${search}` : path
}
